import * as React from 'react';

import * as styles from '../shared/clickable.module.less';

interface IButtonProps {
  variant: 'primary' | 'secondary';
  isDecorated?: boolean;
  children: string;
  onClick?: React.MouseEventHandler;
  type?: 'button' | 'reset' | 'submit';
  isAnchor?: boolean;
  href?: string;
}

export const Button = ({
  variant = 'primary',
  isDecorated,
  children,
  onClick,
  type = 'button',
  isAnchor = false,
  href,
  disabled,
  className,
}: IButtonProps & React.HTMLProps<HTMLButtonElement>): React.ReactElement => {
  const baseClassName = `${styles.clickable} ${styles[variant]} ${
    isDecorated ? styles.decorated : ''
  } ${className || ''}`;

  if (isAnchor)
    return (
      <a className={baseClassName} href={href}>
        {children}
      </a>
    );

  return (
    <button
      type={type}
      disabled={disabled}
      className={baseClassName}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
